var map = {
	"./ku.png": "42a5",
	"./menu/ax.png": "baa0",
	"./menu/jk.png": "d0b8",
	"./menu/jk_action.png": "636a",
	"./menu/js.png": "6da5",
	"./menu/js_action.png": "99d5",
	"./menu/pl.png": "3726",
	"./menu/pl_action.png": "8c9d",
	"./menu/qx.png": "36a7",
	"./menu/qx_action.png": "6eb0",
	"./menu/sm.png": "f582",
	"./menu/sm_action.png": "652b",
	"./menu/zh.png": "420e",
	"./menu/zh_action.png": "c699",
	"./menu/zn.png": "842f",
	"./menu/zn_action.png": "4254",
	"./weather.png": "b18e",
	"./xiao.png": "d9aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";